// extracted by mini-css-extract-plugin
export var clearButton = "sv9Vy";
export var enter = "lj2vp";
export var enterActive = "yPEDx";
export var exit = "Mtn0p";
export var exitActive = "ZfvCU";
export var link = "myQC7";
export var main = "eNbxQ";
export var message = "k8gY9";
export var messageError = "Bxh6h";
export var messageExtended = "gNQup";
export var messageRegular = "oulUd";
export var subtext = "aVC8V";
export var text = "Ls3B6";